import { render, staticRenderFns } from "./APTransHistory.vue?vue&type=template&id=c0c8d1ec&scoped=true&"
import script from "./APTransHistory.vue?vue&type=script&lang=js&"
export * from "./APTransHistory.vue?vue&type=script&lang=js&"
import style0 from "./APTransHistory.vue?vue&type=style&index=0&id=c0c8d1ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c8d1ec",
  null
  
)

component.options.__file = "APTransHistory.vue"
export default component.exports